import { AuroraBackground } from '../componentes/aurora-background';
import { AuthCard } from '../componentes/entrar/auth-card';
import { BrandPanel } from '../componentes/entrar/brand-panel';
import { CadastroForm } from '../componentes/entrar/cadastro-form';

/**
 * Autocadastro, no MESMO layout do login — fundo animado, cartão flutuante,
 * marca à esquerda, formulário à direita.
 *
 * Reaproveitar o layout não é economia de código: é o que faz a porta de
 * entrada parecer a mesma casa. Uma tela de cadastro com outra composição
 * ensinaria a quem chega que criar conta e entrar são dois produtos.
 *
 * Nenhuma regra mora aqui — `CadastroForm` é quem chama
 * `useSessao().criarEscritorio`.
 */
export function CriarConta(): JSX.Element {
  return (
    <main className="relative grid min-h-screen place-items-center overflow-hidden p-4 sm:p-8">
      <AuroraBackground />
      <AuthCard>
        <BrandPanel />
        <CadastroForm />
      </AuthCard>
    </main>
  );
}
